import AppVersionChecker from './AppVersionChecker';

export default AppVersionChecker;
